const ROLES = {
  Admin: 5150,
  User: 2001,
};

export default ROLES;
